<h2 class="!mt-0">
  {{ 'CONFIG.EDIT.TITLE' | translate }}
</h2>

<form [formGroup]="editForm">
  <div class="grid grid-cols-2 gap-4">
    <!-- ID (readonly) -->
    <mat-form-field class="w-full">
      <mat-label>{{ 'CONFIG.FIELDS.ID' | translate }}</mat-label>
      <input formControlName="id" matInput readonly />
    </mat-form-field>

    <!-- CreatedAt (readonly) -->
    <mat-form-field class="w-full">
      <mat-label>{{ 'CONFIG.FIELDS.CREATED_AT' | translate }}</mat-label>
      <input formControlName="createdAt" matInput readonly />
    </mat-form-field>

    <!-- UpdatedAt (readonly) -->
    <mat-form-field class="w-full">
      <mat-label>{{ 'CONFIG.FIELDS.UPDATED_AT' | translate }}</mat-label>
      <input formControlName="updatedAt" matInput readonly />
    </mat-form-field>

    <!-- Nombre -->
    <mat-form-field class="w-full">
      <mat-label>{{ 'CONFIG.FIELDS.NOMBRE' | translate }}</mat-label>
      <input formControlName="nombre" matInput />
    </mat-form-field>

    <!-- Módulo (readonly) -->
    <mat-form-field class="w-full">
      <mat-label>{{ 'CONFIG.FIELDS.MODULO' | translate }}</mat-label>
      <input formControlName="Modulo" matInput readonly />
    </mat-form-field>

    <!-- Valor -->
    <mat-form-field class="w-full">
      <mat-label>{{ 'CONFIG.FIELDS.VALOR' | translate }}</mat-label>
      <input formControlName="valor" matInput />
    </mat-form-field>

    <!-- Descripción -->
    <mat-form-field class="w-full">
      <mat-label>{{ 'CONFIG.FIELDS.DESCRIPCION' | translate }}</mat-label>
      <input formControlName="Descripcion" matInput />
    </mat-form-field>

    <!-- Activo -->
    <mat-form-field class="w-full">
      <mat-label>{{ 'CONFIG.FIELDS.ACTIVO' | translate }}</mat-label>
      <mat-select formControlName="activo">
        <mat-option [value]="1">{{ 'COMMON.YES' | translate }}</mat-option>
        <mat-option [value]="0">{{ 'COMMON.NO' | translate }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <!-- Botones -->
  <div class="flex justify-between gap-4 mt-12">
    <app-button expand="full" color="secondary" (click)="goBack()">
      {{ 'COMMON.CANCEL' | translate }}
    </app-button>
    <app-button expand="full" (click)="onUpdate()">
      {{ 'COMMON.CONFIRM' | translate }}
    </app-button>
  </div>
</form>


<style>
  .grid {
    display: grid;
  }
  .grid-cols-2 {
    grid-template-columns: repeat(2, 1fr);
  }
  .gap-4 {
    gap: 16px;
  }
  .flex {
    display: flex;
  }
  .w-full {
    width: 100%;
  }
  .mt-12 {
    margin-top: 3rem;
  }
</style>
